import React from 'react';
import CustomModal from './CustomModal';
import CustomButton from './CustomButton';
import './CustomConfirmationModal.css';

interface CustomConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const CustomConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isLoading = false,
  maxWidth = 'xs',
}: CustomConfirmationModalProps) => {
  return (
    <CustomModal isOpen={isOpen} handleClose={onClose} title={title} icon={false} maxWidth={maxWidth}>
      <div className="confirmation-message">{message}</div>
      <div className="confirmation-buttons">
        <CustomButton variant="secondary" buttonText={cancelText} buttonAction={onClose} />
        <CustomButton variant="primary" buttonText={confirmText} buttonAction={onConfirm} loading={isLoading} />
      </div>
    </CustomModal>
  );
};

export default CustomConfirmationModal;
